import { Component, OnInit } from '@angular/core';

@Component({
    selector: "app-service-charpente",
    templateUrl: "./service-charpente.component.html",
    styleUrls: ["./service-charpente.component.scss"],
})
export class ServiceCharpenteComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
